<template>
	<div class="wrapper">
		<div class="header">
			<h3>选择{{resourceTypeData[resourceTypeId]}}项目</h3>
			<span class="icon iconfont icon-x" @click="closePage"></span>
		</div>
		<div class="main">
			<p class="time-box">{{time}}    行程安排</p>
			<div class="projectChecked-box">
				<span>近期选择：</span>
				<div class="projectChecked-right">
					<div v-for="(item, i) in localData" :key="i" class="checkListItem">
						<template v-if="uuidObj[item.uuid]">
							<input type="checkbox" name="project" :checked="uuidObj[item.uuid]['checkedStatus']" @change="checkedStatus(item.uuid)" >
							<span class="projectName">{{item.name}}</span>
							<span v-if="uuidObj[item.uuid].checkedStatus == false">{{uuidObj[item.uuid].standardPrice}}</span>
							<div class="hidden-box" v-else>
								<template v-if="resourceTypeId == 1">
									<input type="text" class="textVal" v-model="uuidObj[item.uuid].standardPrice">
								</template>
								<template v-else-if="resourceTypeId == 2">
									<input type="text" class="textVal" v-model="uuidObj[item.uuid].standardPrice">
								</template>
								<template v-else-if="resourceTypeId == 3">
									<input type="text" class="textVal" v-model="uuidObj[item.uuid].standardPrice">
									<span> x </span>
									<input type="number" class="numVal" v-model="uuidObj[item.uuid].num">
									<span> 加 </span>
									<input type="number" class="numVal" v-model="uuidObj[item.uuid].jia">
									<span> 拼 </span>
									<input type="number" v-model="uuidObj[item.uuid].pin" class="numVal">
								</template>
								<template v-else-if="resourceTypeId == 6">
									<input type="text" class="textVal" v-model="uuidObj[item.uuid].standardPrice">
									<span> x </span>
									<input type="number" class="numVal" v-model="uuidObj[item.uuid].num">
								</template>
								<template v-else>
								</template>
							</div>
						</template>
					</div>


				</div>
			</div>
			<p class="groupNum">组团人数：<span v-if="adult && adult != ''">{{adult}}成人 </span> <span v-if="children && children != ''"> {{children}}儿童 </span> <span v-if="baby && baby != ''"> {{baby}}婴儿</span></p>
			<div class="main-search">
				<div class="search-box">
					<span>搜索：</span>
					<el-input v-model="keywords" placeholder="项目资源关键字" size="mini" class="inpWidth"></el-input>
					<span class="icon iconfont icon-search" @click="searchResource"></span>
				</div>
				<div class="projectChecked-box">
					<span>{{resourceTypeData[resourceTypeId]}}：</span>
					<div class="projectChecked-right">
						<div v-for="(item, i) in allData" :key="i" class="checkListItem">
							<template v-if="uuidObj[item.uuid]">
								<input type="checkbox" name="project" :checked="uuidObj[item.uuid]['checkedStatus']" @change="checkedStatus(item.uuid)" value="">
								<span class="projectName">{{item.name}}</span>
								<!-- <el-checkbox :label="item.name" class="projectName" @change="checkedStatus(item.uuid)"></el-checkbox> -->
								<span v-if="uuidObj[item.uuid].checkedStatus == false">{{uuidObj[item.uuid].standardPrice}}</span><!-- {{uuidObj[item.uuid].standardPrice}} -->
								<div class="hidden-box" v-else>
									<template v-if="resourceTypeId === '1'">
										<input type="text" class="textVal" v-model="uuidObj[item.uuid].standardPrice">
									</template>
									<template v-else-if="resourceTypeId === '2'">
										<input type="text" class="textVal" v-model="uuidObj[item.uuid].standardPrice">
									</template>
									<template v-else-if="resourceTypeId === '3'">
										<input type="text" class="textVal" v-model="uuidObj[item.uuid].standardPrice"><span> x </span>
										<input type="number" class="numVal" v-model="uuidObj[item.uuid].num"><span> 加 </span>
										<input type="number" class="numVal" v-model="uuidObj[item.uuid].jia"><span>
											拼 </span><input type="number" v-model="uuidObj[item.uuid].pin" class="numVal">
									</template>
									<template v-else-if="resourceTypeId === '6'">
										<input type="text" class="textVal" v-model="uuidObj[item.uuid].standardPrice"><span> x </span>
										<input type="number" class="numVal" v-model="uuidObj[item.uuid].num">
									</template>
									<template v-else>
										<input type="text" class="textVal" v-model="uuidObj[item.uuid].standardPrice">
									</template>
								</div>
							</template>
						</div>

					</div>
				</div>
			</div>
		</div>
		<div class="footer">
			<el-button size="small" @click="closePage">取消</el-button>
			<el-button type="primary" size="small" @click="save">完成</el-button>
		</div>
	</div>
</template>

<script>
	import chooseResourceService from "../../service/chooseResourceService";

	export default {
		data: function() {
			return {
				resourceTypeId: '', //项目类型
				uuidObj: {},
				keywords: "", //搜索关键字
				localData: [], //最近选择项目
				allData: [], //所有项目
				time:'',
				adult:'',
				children:'',
				baby:'',
				resourceTypeData:{
					"1":"景点",
					"2":"交通",
					"3":"住宿",
					"4":"餐饮",
					"5":"特殊",
					"6":"导游",
					"7":"其他"
				}
			}
		},

		mounted: function() {
			this.loadData();
			if (localStorage.getItem("resource"+this.resourceTypeId) !== null) {
				this.localData = JSON.parse(localStorage.getItem("resource"+this.resourceTypeId));
			}
		},
		methods: {
			async loadData() {
				this.resourceTypeId = this.$route.query.resourceTypeId;
				this.adult = this.$route.query.adult;
				this.children = this.$route.query.children;
				this.baby = this.$route.query.baby;
				this.time = this.$route.query.time;
				let resp = await chooseResourceService.getResourcesList(this.resourceTypeId, this.keywords);
				if (resp.data.Status === "1") {
					let data = resp.data.Data.data;
					data.forEach((item) => {
						if(item.enable === "1"){
							item.checkedStatus = false;
							item.num = 1;
							item.jia = 0;
							item.pin = 0;
							this.uuidObj[item.uuid] = item;
							this.allData.push(item);
						}
						
					})
				}
			},
			searchResource(){
				this.allData=[];
				this.loadData();
			},
			checkedStatus(uuid) {
				this.uuidObj[uuid]['checkedStatus'] = !this.uuidObj[uuid]['checkedStatus'];
			},
			save() {
				let uuidObj = this.uuidObj;
				let localData = [];
				for (var m in uuidObj) {
					if (uuidObj[m]['checkedStatus'] === true) {
						uuidObj[m].addBedPrice = uuidObj[m].addBedPrice !== undefined ? uuidObj[m].addBedPrice : 0;
						uuidObj[m].sharingPrice = uuidObj[m].sharingPrice !== undefined ? uuidObj[m].sharingPrice : 0;
						uuidObj[m].tatal = (uuidObj[m].standardPrice) * (uuidObj[m].num) + (uuidObj[m].addBedPrice) * (uuidObj[m].jia) + (uuidObj[m].pin) * (uuidObj[m].sharingPrice);
						localData.push(uuidObj[m]);
					}
				}
				localStorage.setItem("resource"+this.resourceTypeId, JSON.stringify(localData));
				window.parent.resourceData = localData;
			},
			closePage() {
				parent.$("chooseResource").hide();
			}
		}
	}
</script>

<style scoped>
	.wrapper {
		width: 800px;
		margin: 0 auto;
		border: 1px solid rgba(235, 235, 235, 1);
	}

	div,
	p,
	span,
	input {
		font-size: 14px;
	}

	.textVal {
		width: 60px;
		border: 1px solid rgba(235, 235, 235, 1);
		padding-right: 3px;
		text-align: right;
	}

	.numVal {
		width: 30px;
		border: 1px solid rgba(235, 235, 235, 1);
		padding-left: 3px;
	}

	.header {
		height: 56px;
		line-height: 56px;
		padding: 0 20px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid rgba(235, 235, 235, 1);
		box-sizing: border-box;
	}

	.header h3 {
		font-size: 14px;
		color: rgba(0, 0, 0, 0.647058823529412);
		font-weight: normal;
	}

	.header span {
		color: rgba(0, 0, 0, 0.647058823529412);
	}

	.main {
		padding: 0 30px 30px;
		border-bottom: 1px solid rgba(235, 235, 235, 1);
	}

	.projectChecked-box {
		display: flex;
		justify-content: flex-start;
	}

	.time-box {
		font-size: 12px;
		color: rgba(0, 0, 0, 0.349019607843137);
	}

	.hidden-box {
		display: flex;
		align-items: center;
		color: #333333;
	}

	.hidden-box span {
		margin: 0 5px;
	}

	.projectChecked-right {
		display: flex;
		align-items: center;
		flex: 1;
		flex-wrap: wrap;
	}

	.projectChecked-right .allCheckList {
		display: flex;
		align-items: center;
		flex: 1;
		flex-wrap: wrap;
	}

	.projectChecked-right .checkListItem {
		flex: 0 0 50%;
		display: flex;
		align-items: center;
		margin-bottom: 15px;
		height: 22px;
	}

	.projectChecked-right .checkListItem input {
		vertical-align: middle;
	}

	.projectChecked-right .checkListItem span {
		color: #333333;
	}

	.projectChecked-right span.projectName {
		margin-right: 20px;
		text-decoration: underline;
		color: #00ABEA;
	}

	.groupNum {
		text-align: right;
		font-size: 12px;
		color: rgba(0, 0, 0, 0.349019607843137);
		border-bottom: 1px solid rgba(235, 235, 235, 1);
		margin-bottom: 0;
		padding-bottom: 10px;
	}
	.groupNum span{
		font-size: 12px;
	}

	.search-box {
		display: flex;
		align-items: center;
		margin: 20px 0;
		color: #333;
	}

	.search-box .inpWidth {
		width: 200px;
		margin-right: 10px;
	}

	.footer {
		text-align: right;
		padding: 10px 20px;
	}
	.icon{
		color: #8d8d8d;
	}
</style>
